// Seen-state for the What's New topbar dot lives in Auth0 user_metadata
// (releaseNotesLastSeen) so it follows the account across browsers/devices —
// same approach as the driver.js guided tours (seenTours). Release notes
// themselves come from the API (rrgpu.release_note via useReleaseNotes). Dates
// are ISO date-only strings, which compare correctly lexicographically.

export const hasUnseenReleases = (lastSeen: string | undefined, latestDate: string | undefined) =>
    !!latestDate && (lastSeen ?? "") < latestDate
